module.exports = __webpack_public_path__ + "static/media/view_a_ruberic(admins).e21a7e92.mp4";